import axios from "axios";
import { LoginResponse } from "../../types/authTypes";

const API_URL = process.env.REACT_APP_API_URL || "http://localhost:3000/api";

export const login = async (username: string, password: string): Promise<LoginResponse> => {
    try {
        const response = await axios.post<LoginResponse>(`${API_URL}/login`, { username, password });
        return response.data;
    } catch (error: any) {
        throw new Error(error.response?.data?.message || "Login failed. Please try again.");
    }
};

export const register = async (name: string, username: string, email: string, password: string) => {
    try {
        const response = await axios.post(`${API_URL}/register`, {
        name,
        username,
        email,
        password,
        });
        return response.data;
    } catch (error: any) {
        throw new Error(error.response?.data?.message || "Registration failed. Please try again.");
    }
};

export const logout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("user");
};
